/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * appointment status
 * @export
 */
export const UserAppointmentStatusEnum = {
    WaitingRoom: 'WAITING_ROOM',
    Scheduled: 'SCHEDULED',
    Honoured: 'HONOURED',
    NotHonoured: 'NOT_HONOURED',
    ToValidate: 'TO_VALIDATE',
    Cancelled: 'CANCELLED'
} as const;
export type UserAppointmentStatusEnum = typeof UserAppointmentStatusEnum[keyof typeof UserAppointmentStatusEnum];


export function instanceOfUserAppointmentStatusEnum(value: any): boolean {
    for (const key in UserAppointmentStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(UserAppointmentStatusEnum, key)) {
            if (UserAppointmentStatusEnum[key as keyof typeof UserAppointmentStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserAppointmentStatusEnumFromJSON(json: any): UserAppointmentStatusEnum {
    return UserAppointmentStatusEnumFromJSONTyped(json, false);
}

export function UserAppointmentStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAppointmentStatusEnum {
    return json as UserAppointmentStatusEnum;
}

export function UserAppointmentStatusEnumToJSON(value?: UserAppointmentStatusEnum | null): any {
    return value as any;
}

export function UserAppointmentStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): UserAppointmentStatusEnum {
    return value as UserAppointmentStatusEnum;
}

